export default {"src":"/_next/static/media/carHalfCircle_40.0a4da05d.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};